module.exports = __webpack_public_path__ + "img/s7.6a92bf0a.png";